module.exports = __webpack_public_path__ + "img/airplane.86c85916.jpg";